import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable, timer } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { HomeIaRateLimitService } from "../services/home-ia-rate-limit.service";
import { environment } from "../../environments/environment";

@Injectable()
export class HomeIaRateLimitInterceptor implements HttpInterceptor {
  constructor(private readonly rateLimitService: HomeIaRateLimitService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isHomeIaRequest =
      (environment.homeIaApiUrl && request.url.includes(environment.homeIaApiUrl)) ||
      request.url.includes("/api/home-ia");

    const delayMs = isHomeIaRequest ? this.rateLimitService.getDelayMs() : 0;
    const request$ = delayMs > 0 ? timer(delayMs).pipe(switchMap(() => next.handle(request))) : next.handle(request);

    return request$.pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.captureRetryAfter(event.headers?.get("Retry-After"));
          }
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            this.captureRetryAfter(error.headers?.get("Retry-After"));
          }
        }
      })
    );
  }

  private captureRetryAfter(value: string | null): void {
    if (!value) {
      return;
    }
    const seconds = Number(value);
    if (!Number.isNaN(seconds)) {
      this.rateLimitService.setRetryAfterSeconds(seconds);
    }
  }
}
